import * as THREE from 'three';
import gsap from 'gsap';

import Experience from '../Experience';

import Renderer from '../Renderer';
import GuitarAudio from '../Game/Audio';
import Animations from './Animations';

const next = document.querySelector('[data-next-scene]');
const restart = document.querySelector('[data-restart-btn]');
let instance = null;

export default class Car {
    constructor() {
        if(instance) {
            return instance;
        }

        instance = this;

        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.renderer = new Renderer();
        this.resources = this.experience.resources;
        this.isCameraWentInside = false;
        this.resource = this.resources.items.carModel;
        this.animations = new Animations(this.resource);

        this.isRestartInProgress = false;
        this.isGameStarted = false;

        this.setModel();
        this.animations.setInitialAnimations();

        next.addEventListener('click', () => this.startExperience());
        restart.addEventListener('click', () => this.handleRestart());
    }

    startExperience() {
        if (this.isGameStarted) return;

        this.animations.goInsideTheCar();
        this.isGameStarted = true;
    }

    setModel() {
        this.model = this.resource.scene;
        console.log(this.resource);
        this.experience.camera.instance = this.resource.cameras[0];
        this.experience.camera.instance.far = 800;
        this.experience.camera.resize();
        this.renderer.setPostProcessing();

        this.model.children[3].traverse(n => {
            if (n.isMesh) {
                n.frustumCulled = false;
            }
        });
        this.scene.add(this.model);

        this.addEmissiveToSelectedMeshes();
    }

    addEmissiveToSelectedMeshes() {
        this.scene.traverse(n => {
            if (n.isMesh) {
                if (n.name === 'TunnelLightPoints001') {
                    n.material.emissiveIntensity = 5
                }

                if (
                    n.name === 'GuitarHeroLineA'
                    || n.name === 'GuitarHeroLineS'
                    || n.name === 'GuitarHeroLineD'
                    || n.name === 'GuitarHeroLineF'
                    || n.name === 'Number_1'
                    || n.name === 'Number_3'
                    || n.name === 'Number_2_'
                ) {
                    n.material = new THREE.MeshBasicMaterial({ color: 0xE69122 });
                    n.layers.enable(this.renderer.BLOOM_SCENE);
                }

                if (
                    n.name === 'CarBackLights'
                    || n.name === 'CarHeadLights'
                    || n.name ===  'CircleS'
                    || n.name ===  'CircleA'
                    || n.name ===  'CircleD'
                    || n.name ===  'CircleF'
                ) {
                    n.layers.enable(this.renderer.BLOOM_SCENE);
                }
            }
        });
    }



    handleRestart() {
        if (this.isRestartInProgress) return;

        this.animations.goInsideTheCar();
        this.isRestartInProgress = true;

        gsap.to('[data-restart]', { autoAlpha: 0, delay: 1, duration: 1 })
            .then(() => this.isRestartInProgress = false);
    }

    update() {
        this.animations.update();
    }
}